import { FoodItem } from './db-types';

export const foods1: FoodItem[] = [
  { id: "ale", en: "Ale", fr: "Ale", category: "alcohol" },
  { id: "amaretto", en: "Amaretto", fr: "Amaretto", category: "alcohol" },
  { id: "aperol", en: "Aperol", fr: "Aperol", category: "alcohol" },
  { id: "akvavit", en: "Aquavit", fr: "Aquavit", category: "alcohol" },
  { id: "armagnac", en: "Armagnac", fr: "Armagnac", category: "alcohol" },
  { id: "baileys", en: "Baileys", fr: "Baileys", category: "alcohol" },
  { id: "beer", en: "Beer", fr: "Bière", category: "alcohol" },
  { id: "bourbon", en: "Bourbon", fr: "Bourbon", category: "alcohol" },
  { id: "brandy", en: "Brandy", fr: "Brandy", category: "alcohol" },
  { id: "calvados", en: "Calvados", fr: "Calvados", category: "alcohol" },
  { id: "campari", en: "Campari", fr: "Campari", category: "alcohol" },
  { id: "champagne", en: "Champagne", fr: "Champagne", category: "alcohol" },
  { id: "cider", en: "Cider", fr: "Cidre", category: "alcohol" },
  { id: "cognac", en: "Cognac", fr: "Cognac", category: "alcohol" },
  { id: "cointreau", en: "Cointreau", fr: "Cointreau", category: "alcohol" },
  { id: "craft_beer", en: "Craft Beer", fr: "Bière artisanale", category: "alcohol" },
  { id: "dark_rum", en: "Dark Rum", fr: "Rhum brun", category: "alcohol" },
  { id: "dessert_wine", en: "Dessert Wine", fr: "Vin de dessert", category: "alcohol" },
  { id: "gin", en: "Gin", fr: "Gin", category: "alcohol" },
  { id: "gluhwein", en: "Glühwein", fr: "Vin chaud", category: "alcohol" },
  { id: "grand_marnier", en: "Grand Marnier", fr: "Grand Marnier", category: "alcohol" },
  { id: "grappa", en: "Grappa", fr: "Grappa", category: "alcohol" },
  { id: "hard_seltzer", en: "Hard Seltzer", fr: "Hard seltzer", category: "alcohol" },
  { id: "ipa", en: "IPA", fr: "IPA", category: "alcohol" },
  { id: "irish_whiskey", en: "Irish Whiskey", fr: "Whisky irlandais", category: "alcohol" },
  { id: "kahlua", en: "Kahlúa", fr: "Kahlúa", category: "alcohol" },
  { id: "kir", en: "Kir", fr: "Kir", category: "alcohol" },
  { id: "lager", en: "Lager", fr: "Lager", category: "alcohol" },
  { id: "limoncello", en: "Limoncello", fr: "Limoncello", category: "alcohol" },
  { id: "liqueur", en: "Liqueur", fr: "Liqueur", category: "alcohol" },
  { id: "mezcal", en: "Mezcal", fr: "Mezcal", category: "alcohol" },
  { id: "non_alcoholic_beer", en: "Non-Alcoholic Beer", fr: "Bière sans alcool", category: "alcohol" },
  { id: "pastis", en: "Pastis", fr: "Pastis", category: "alcohol" },
  { id: "pilsner", en: "Pilsner", fr: "Pilsner", category: "alcohol" },
  { id: "port", en: "Port Wine", fr: "Porto", category: "alcohol" },
  { id: "porter", en: "Porter", fr: "Porter", category: "alcohol" },
  { id: "prosecco", en: "Prosecco", fr: "Prosecco", category: "alcohol" },
  { id: "red_wine", en: "Red Wine", fr: "Vin rouge", category: "alcohol" },
  { id: "rose_wine", en: "Rosé Wine", fr: "Rosé", category: "alcohol" },
  { id: "rum", en: "Rum", fr: "Rhum", category: "alcohol" },
  { id: "sambuca", en: "Sambuca", fr: "Sambuca", category: "alcohol" },
  { id: "sangria", en: "Sangria", fr: "Sangria", category: "alcohol" },
  { id: "scotch", en: "Scotch", fr: "Scotch", category: "alcohol" },
  { id: "sherry", en: "Sherry", fr: "Xérès", category: "alcohol" },
  { id: "soju", en: "Soju", fr: "Soju", category: "alcohol" },
  { id: "sparkling_wine", en: "Sparkling Wine", fr: "Vin mousseux", category: "alcohol" },
  { id: "stout", en: "Stout", fr: "Stout", category: "alcohol" },
  { id: "tequila", en: "Tequila", fr: "Tequila", category: "alcohol" },
  { id: "tinto_de_verano", en: "Tinto de Verano", fr: "Tinto de verano", category: "alcohol" },
  { id: "tinto_verano", en: "Tinto de Verano", fr: "Tinto de verano", category: "alcohol" },
  { id: "vermouth", en: "Vermouth", fr: "Vermouth", category: "alcohol" },
  { id: "vodka", en: "Vodka", fr: "Vodka", category: "alcohol" },
  { id: "wheat_beer", en: "Wheat Beer", fr: "Bière blanche", category: "alcohol" },
  { id: "whiskey", en: "Whiskey", fr: "Whisky", category: "alcohol" },
  { id: "white_rum", en: "White Rum", fr: "Rhum blanc", category: "alcohol" },
  { id: "white_wine", en: "White Wine", fr: "Vin blanc", category: "alcohol" },
  { id: "wine", en: "Wine", fr: "Vin", category: "alcohol" },
  { id: "active_dry_yeast", en: "Active Dry Yeast", fr: "Levure sèche active", category: "bakery" },
  { id: "agar_agar", en: "Agar Agar", fr: "Agar-agar", category: "bakery" },
  { id: "all_purpose_flour", en: "All-Purpose Flour", fr: "Farine tout usage", category: "bakery" },
  { id: "arrowroot", en: "Arrowroot", fr: "Arrow-root", category: "bakery" },
  { id: "baking_chocolate", en: "Baking Chocolate", fr: "Chocolat pâtissier", category: "bakery" },
  { id: "baking_powder", en: "Baking Powder", fr: "Levure chimique", category: "bakery" },
  { id: "baking_soda", en: "Baking Soda", fr: "Bicarbonate de soude", category: "bakery" },
  { id: "biscotti", en: "Biscotti", fr: "Biscotti", category: "bakery" },
  { id: "biscuit", en: "Biscuit", fr: "Biscuit", category: "bakery" },
  { id: "blondie", en: "Blondie", fr: "Blondie", category: "bakery" },
  { id: "blueberry_muffin", en: "Blueberry Muffin", fr: "Muffin aux myrtilles", category: "bakery" },
  { id: "bran_muffin", en: "Bran Muffin", fr: "Muffin au son", category: "bakery" },
  { id: "bread_flour", en: "Bread Flour", fr: "Farine à pain", category: "bakery" },
  { id: "brownie", en: "Brownie", fr: "Brownie", category: "bakery" },
  { id: "cake_flour", en: "Cake Flour", fr: "Farine à gâteau", category: "bakery" },
  { id: "chocolate_chip_cookie", en: "Chocolate Chip Cookie", fr: "Cookie aux pépites de chocolat", category: "bakery" },
  { id: "chocolate_ganache", en: "Chocolate Ganache", fr: "Ganache au chocolat", category: "bakery" },
  { id: "cinnamon_roll", en: "Cinnamon Roll", fr: "Roulé à la cannelle", category: "bakery" },
  { id: "cocoa_powder", en: "Cocoa Powder", fr: "Cacao en poudre", category: "bakery" },
  { id: "coconut_flour", en: "Coconut Flour", fr: "Farine de coco", category: "bakery" },
  { id: "cookie", en: "Cookie", fr: "Cookie", category: "bakery", keywords: ["cookies"] },
  { id: "cornstarch", en: "Cornstarch", fr: "Fécule de maïs", category: "bakery", keywords: ["maizena"] },
  { id: "danish_wienerbrød", en: "Danish", fr: "Viennoiserie danoise", category: "bakery" },
  { id: "donut", en: "Donut", fr: "Beignet", category: "bakery", keywords: ["doughnut"] },
  { id: "financier", en: "Financier", fr: "Financier", category: "bakery" },
  { id: "flour", en: "Flour", fr: "Farine", category: "bakery" },
  { id: "fondant", en: "Fondant", fr: "Fondant", category: "bakery" },
  { id: "food_coloring", en: "Food Coloring", fr: "Colorant alimentaire", category: "bakery" },
  { id: "fresh_yeast", en: "Fresh Yeast", fr: "Levure fraîche", category: "bakery" },
  { id: "frosting", en: "Frosting", fr: "Glaçage", category: "bakery" },
  { id: "gelatin", en: "Gelatin", fr: "Gélatine", category: "bakery" },
  { id: "gluten_free_flour", en: "Gluten-Free Flour", fr: "Farine sans gluten", category: "bakery" },
  { id: "instant_yeast", en: "Instant Yeast", fr: "Levure instantanée", category: "bakery" },
  { id: "kanelbulle", en: "Kanelbulle", fr: "Kanelbulle", category: "bakery" },
  { id: "langue_de_chat", en: "Langue de Chat", fr: "Langue de chat", category: "bakery" },
  { id: "macaron", en: "Macaron", fr: "Macaron", category: "bakery" },
  { id: "macaroon", en: "Macaroon", fr: "Rocher coco", category: "bakery" },
  { id: "madeleines", en: "Madeleines", fr: "Madeleines", category: "bakery" },
  { id: "marzipan", en: "Marzipan", fr: "Massepain", category: "bakery", keywords: ["pâte d'amande"] },
  { id: "meringue", en: "Meringue", fr: "Meringue", category: "bakery" },
  { id: "muffin", en: "Muffin", fr: "Muffin", category: "bakery" },
  { id: "oatmeal_cookie", en: "Oatmeal Cookie", fr: "Cookie aux flocons d'avoine", category: "bakery" },
  { id: "palmier", en: "Palmier", fr: "Palmier", category: "bakery" },
  { id: "pastry_flour", en: "Pastry Flour", fr: "Farine à pâtisserie", category: "bakery" },
  { id: "peanut_butter_cookie", en: "Peanut Butter Cookie", fr: "Cookie au beurre de cacahuète", category: "bakery" },
  { id: "pectin", en: "Pectin", fr: "Pectine", category: "bakery" },
  { id: "potato_starch", en: "Potato Starch", fr: "Fécule de pomme de terre", category: "bakery" },
  { id: "rice_flour", en: "Rice Flour", fr: "Farine de riz", category: "bakery" },
  { id: "scone", en: "Scone", fr: "Scone", category: "bakery" },
  { id: "scones_uk", en: "Scones", fr: "Scones anglais", category: "bakery" },
  { id: "self_rising_flour", en: "Self-Rising Flour", fr: "Farine auto-levante", category: "bakery" },
  { id: "shortbread", en: "Shortbread", fr: "Shortbread", category: "bakery" },
  { id: "sprinkles", en: "Sprinkles", fr: "Vermicelles", category: "bakery" },
  { id: "sticky_bun", en: "Sticky Bun", fr: "Brioche collante", category: "bakery" },
  { id: "sugar_cookie", en: "Sugar Cookie", fr: "Sablé", category: "bakery" },
  { id: "tapioca_flour", en: "Tapioca Flour", fr: "Fécule de tapioca", category: "bakery" },
  { id: "tuile", en: "Tuile", fr: "Tuile", category: "bakery" },
  { id: "whole_wheat_flour", en: "Whole Wheat Flour", fr: "Farine complète", category: "bakery" },
  { id: "yeast", en: "Yeast", fr: "Levure", category: "bakery" },
  { id: "agua_fresca", en: "Agua Fresca", fr: "Agua fresca", category: "beverage" },
  { id: "americano", en: "Americano", fr: "Americano", category: "beverage" },
  { id: "apple_juice", en: "Apple Juice", fr: "Jus de pomme", category: "beverage" },
  { id: "black_tea", en: "Black Tea", fr: "Thé noir", category: "beverage" },
  { id: "bubble_tea", en: "Bubble Tea", fr: "Bubble tea", category: "beverage" },
  { id: "cappuccino", en: "Cappuccino", fr: "Cappuccino", category: "beverage" },
  { id: "carrot_juice", en: "Carrot Juice", fr: "Jus de carotte", category: "beverage" },
  { id: "chai", en: "Chai", fr: "Chai", category: "beverage" },
  { id: "chamomile_tea", en: "Chamomile Tea", fr: "Tisane à la camomille", category: "beverage" },
  { id: "club_soda", en: "Club Soda", fr: "Soda", category: "beverage" },
  { id: "coconut_water", en: "Coconut Water", fr: "Eau de coco", category: "beverage" },
  { id: "coffee", en: "Coffee", fr: "Café", category: "beverage" },
  { id: "cola", en: "Cola", fr: "Cola", category: "beverage" },
  { id: "cold_brew", en: "Cold Brew", fr: "Cold brew", category: "beverage" },
  { id: "cranberry_juice", en: "Cranberry Juice", fr: "Jus de canneberge", category: "beverage" },
  { id: "decaf", en: "Decaf Coffee", fr: "Décaféiné", category: "beverage" },
  { id: "diet_soda", en: "Diet Soda", fr: "Soda light", category: "beverage" },
  { id: "earl_grey", en: "Earl Grey", fr: "Earl Grey", category: "beverage" },
  { id: "energy_drink", en: "Energy Drink", fr: "Boisson énergisante", category: "beverage" },
  { id: "english_breakfast", en: "English Breakfast Tea", fr: "English Breakfast", category: "beverage" },
  { id: "espresso", en: "Espresso", fr: "Expresso", category: "beverage" },
  { id: "fresh_juice", en: "Fresh Juice", fr: "Jus frais", category: "beverage" },
  { id: "ginger_ale", en: "Ginger Ale", fr: "Ginger ale", category: "beverage" },
  { id: "ginger_tea", en: "Ginger Tea", fr: "Thé au gingembre", category: "beverage" },
  { id: "glogg", en: "Glögg", fr: "Glögg", category: "beverage" },
  { id: "grape_juice", en: "Grape Juice", fr: "Jus de raisin", category: "beverage" },
  { id: "grapefruit_juice", en: "Grapefruit Juice", fr: "Jus de pamplemousse", category: "beverage" },
  { id: "green_tea", en: "Green Tea", fr: "Thé vert", category: "beverage" },
  { id: "herbal_tea", en: "Herbal Tea", fr: "Tisane", category: "beverage", keywords: ["infusion"] },
  { id: "horchata", en: "Horchata", fr: "Horchata", category: "beverage" },
  { id: "hot_chocolate", en: "Hot Chocolate", fr: "Chocolat chaud", category: "beverage" },
  { id: "iced_coffee", en: "Iced Coffee", fr: "Café glacé", category: "beverage" },
  { id: "iced_tea", en: "Iced Tea", fr: "Thé glacé", category: "beverage" },
  { id: "instant_coffee", en: "Instant Coffee", fr: "Café soluble", category: "beverage" },
  { id: "irish_coffee", en: "Irish Coffee", fr: "Irish coffee", category: "beverage" },
  { id: "jamaica_drink", en: "Jamaica", fr: "Hibiscus", category: "beverage" },
  { id: "kombucha", en: "Kombucha", fr: "Kombucha", category: "beverage" },
  { id: "kompot", en: "Kompot", fr: "Kompot", category: "beverage" },
  { id: "kvass", en: "Kvass", fr: "Kvass", category: "beverage" },
  { id: "latte", en: "Latte", fr: "Café au lait", category: "beverage" },
  { id: "lemon_juice", en: "Lemon Juice", fr: "Jus de citron", category: "beverage" },
  { id: "lemon_lime_soda", en: "Lemon-Lime Soda", fr: "Soda citron", category: "beverage" },
  { id: "lemonade", en: "Lemonade", fr: "Limonade", category: "beverage", keywords: ["citronnade"] },
  { id: "lime_juice", en: "Lime Juice", fr: "Jus de citron vert", category: "beverage" },
  { id: "macchiato", en: "Macchiato", fr: "Macchiato", category: "beverage" },
  { id: "mango_lassi", en: "Mango Lassi", fr: "Lassi à la mangue", category: "beverage" },
  { id: "masala_chai", en: "Masala Chai", fr: "Chai masala", category: "beverage" },
  { id: "matcha", en: "Matcha", fr: "Matcha", category: "beverage" },
  { id: "matcha_latte", en: "Matcha Latte", fr: "Latte matcha", category: "beverage" },
  { id: "milkshake", en: "Milkshake", fr: "Milk-shake", category: "beverage" },
  { id: "mineral_water", en: "Mineral Water", fr: "Eau minérale", category: "beverage" },
  { id: "mocha", en: "Mocha", fr: "Moka", category: "beverage" },
  { id: "oolong_tea", en: "Oolong Tea", fr: "Thé oolong", category: "beverage" },
  { id: "orange_juice", en: "Orange Juice", fr: "Jus d'orange", category: "beverage" },
  { id: "peppermint_tea", en: "Peppermint Tea", fr: "Tisane à la menthe", category: "beverage" },
  { id: "pineapple_juice", en: "Pineapple Juice", fr: "Jus d'ananas", category: "beverage" },
  { id: "pomegranate_juice", en: "Pomegranate Juice", fr: "Jus de grenade", category: "beverage" },
  { id: "protein_shake", en: "Protein Shake", fr: "Shake protéiné", category: "beverage" },
  { id: "rooibos", en: "Rooibos", fr: "Rooibos", category: "beverage" },
  { id: "root_beer", en: "Root Beer", fr: "Root beer", category: "beverage" },
  { id: "rose_lassi", en: "Rose Lassi", fr: "Lassi à la rose", category: "beverage" },
  { id: "smoothie", en: "Smoothie", fr: "Smoothie", category: "beverage" },
  { id: "soda", en: "Soda", fr: "Soda", category: "beverage" },
  { id: "sparkling_water", en: "Sparkling Water", fr: "Eau gazeuse", category: "beverage" },
  { id: "sports_drink", en: "Sports Drink", fr: "Boisson sportive", category: "beverage" },
  { id: "tamarindo_drink", en: "Tamarindo", fr: "Tamarin", category: "beverage" },
  { id: "tea", en: "Tea", fr: "Thé", category: "beverage" },
  { id: "thai_iced_tea", en: "Thai Iced Tea", fr: "Thé glacé thaï", category: "beverage" },
  { id: "tomato_juice", en: "Tomato Juice", fr: "Jus de tomate", category: "beverage" },
  { id: "tonic_water", en: "Tonic Water", fr: "Eau tonique", category: "beverage" },
  { id: "turkish_coffee", en: "Turkish Coffee", fr: "Café turc", category: "beverage" },
  { id: "vegetable_juice", en: "Vegetable Juice", fr: "Jus de légumes", category: "beverage" },
  { id: "vietnamese_coffee", en: "Vietnamese Coffee", fr: "Café vietnamien", category: "beverage" },
  { id: "water", en: "Water", fr: "Eau", category: "beverage" },
  { id: "white_tea", en: "White Tea", fr: "Thé blanc", category: "beverage" },
  { id: "arepa", en: "Arepa", fr: "Arepa", category: "bread" },
  { id: "bagel", en: "Bagel", fr: "Bagel", category: "bread" },
  { id: "baguette", en: "Baguette", fr: "Baguette", category: "bread" },
  { id: "banana_bread", en: "Banana Bread", fr: "Pain aux bananes", category: "bread" },
  { id: "bao_bun", en: "Bao Bun", fr: "Bao", category: "bread" },
  { id: "bread", en: "Bread", fr: "Pain", category: "bread" },
  { id: "breadcrumbs", en: "Breadcrumbs", fr: "Chapelure", category: "bread", keywords: ["panko"] },
  { id: "breadstick", en: "Breadstick", fr: "Gressin", category: "bread" },
  { id: "bretzel", en: "Bretzel", fr: "Bretzel", category: "bread" },
  { id: "brioche", en: "Brioche", fr: "Brioche", category: "bread" },
  { id: "challah", en: "Challah", fr: "Challah", category: "bread" },
  { id: "chapati", en: "Chapati", fr: "Chapati", category: "bread" },
  { id: "choux_pastry", en: "Choux Pastry", fr: "Pâte à choux", category: "bread" },
  { id: "ciabatta", en: "Ciabatta", fr: "Ciabatta", category: "bread" },
  { id: "corn_tortilla", en: "Corn Tortilla", fr: "Tortilla de maïs", category: "bread" },
  { id: "cornbread", en: "Cornbread", fr: "Pain de maïs", category: "bread" },
  { id: "crispbread", en: "Crispbread", fr: "Pain croustillant", category: "bread" },
  { id: "croissant", en: "Croissant", fr: "Croissant", category: "bread" },
  { id: "crouton", en: "Crouton", fr: "Croûton", category: "bread" },
  { id: "crumpet", en: "Crumpet", fr: "Crumpet", category: "bread" },
  { id: "danish_pastry", en: "Danish Pastry", fr: "Viennoiserie danoise", category: "bread" },
];
